import React, { Component } from 'react';
import $ from 'jquery';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import analytics from '~/helpers/analytics';
import product from '~/helpers/product';
import { addonsList } from '~/store/Addons/Addons';
import catalogStore from '~/store/Catalog/Catalog';
import { CURRENCY } from '~/store/States/global';
import { cartPospago } from '~/store/States/pospago';

import { withRouter } from '#/renderer/router';
import UI from './Cart.ui';

class Cart extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      accountStore: {},
      warnState: 'warned_once',
      checkoutLock: true,
      addonsList: [],
      addonsListState: false,
      cardMessageError: '',
      tipo: '',
    };
    this.isEmpty = true;
  }

  componentDidMount() {
    document.getElementById('initial').scrollIntoView(true);
    Promise.all([
      this.addonsList(),
      this.deleteAddOns(),
    ]).then(() => {
      Promise.all([
        this.productWarn(),
        this.inventoryStatus(),
      ]).then(([isLogged]) => {
        if (isLogged && this.props.location.state?.mode === 'login') {
          const getCart = this.props.orderStore.getCartInfo;
          const { items } = getCart.data.data;
          const hasPrepago = items.some(it => it.product.type === '1');
          const hasOtros = items.some(it => it.product.type === '4' || it.product.type === '5');
          if (!(hasPrepago && hasOtros)) {
            this.addAddOns();
          }
        }
      });
    });
    const { state } = this.props.location;
    const { history } = this.props;
    if (state && state.cardMessageError) {
      this.state.cardMessageError = state.cardMessageError;
      history.replace('/cart', null);
    }
  }

  addonsList() {
    return addonsList().then((res) => {
      if (res.success) {
        this.setState({
          addonsList: res.data[0].filter(x => x.enabled === true && x.auto_cart === true),
          addonsListState: true,
        });
      }
    });
  }

  async sendAnalytics() {
    try {
      const store = this.props.orderStore;
      const cart = store.getCartInfo?.success ? store.getCartInfo.data.data : null;
      if (cart?.items.length) {
        analytics.checkout(1, cart);
      }
    } catch (error) {
      console.log('Error al enviar analytics de carrito');
    }
  }

  inventoryStatus = async () => {
    const getCart = this.props.orderStore.getCartInfo;
    let checkoutLock = true;
    if (
      getCart
      && getCart.data
      && getCart.data.data
      && getCart.data.data.items[0]
    ) {
      await this.moreProducts(getCart.data.data.items);
      const invStatus = getCart.data.data.items.map(item => catalogStore.inventoryStatusService(item.part_number));
      const invStatusRes = await Promise.all(invStatus);
      for (let i = 0; i < invStatusRes.length; i += 1) {
        const inventoryStatus = invStatusRes[i];
        if (
          inventoryStatus
          && inventoryStatus.data
          && inventoryStatus.data.data
          && inventoryStatus.data.data.status === 'available'
          && inventoryStatus.data.data.quantity >= +getCart.data.data.items[i].quantity
        ) {
          //console.log('inventoryStatus', inventoryStatus.data.data.partnumber, inventoryStatus.data.data.status);
          checkoutLock = false;
        } else {
          checkoutLock = true;
          break;
        }
      }
      this.setState({ checkoutLock });
    }

    const dataPerson = await this.props.accountStore.dataPerson();
    let checkoutRedirect;
    if (dataPerson && !dataPerson.success) {
      checkoutRedirect = (
        <a onClick={() => { this.openModal();
          //blukai function, removido
         }}>
          <span>Continuar</span>
        </a>
      );
    } else {
      checkoutRedirect = (
        <a onClick={(e) => { this.addAddOns(e);
          //blukai function, removido
         }}>
          <span>Continuar</span>
        </a>
      );
    }
    this.setState({ checkoutRedirect });
  };

  deleteAddOns = async () => {
    const getCart = await this.props.orderStore.getCart();
    if (getCart.success && getCart.data && getCart.data.data) {
      const { items, external_referer } = getCart.data.data;
      if (items.length) {
        const validations = items.map((item) => {
          let part_number = item.part_number;
          let plan;
          let plazo;
          let tipo_oferta;
          let price = item.amount[CURRENCY].unit_price;
          if (item.part_number_kit) {
            const { plan: pln, plazo: plz, tipo_oferta: tipo  } = cartPospago(item.part_number_kit);
            part_number = item.part_number_kit;
            plan = pln;
            plazo = plz;
            tipo_oferta = tipo;
            price = +(price / 100).toFixed(2);
          }
          return this.props.orderStore.validateCart({
            part_number: item.part_number,
            price,
            currency: `${CURRENCY}`,
            order_id: external_referer,
            plan,
            plazo,
            tipo_oferta,
          }).then((valid) => {
            if (valid.success && valid.data && valid.data.data && valid.data.data.price_changed) {
              return this.props.orderStore.deleteToCart(part_number);
            } else {
              return false;
            }
          }).then((response) => {
            if (response && response.success && response.data) {
              return this.props.orderStore.addToCart({ part_number, quantity: item.quantity, esim: item.esim });
            }
            return false;
          });
        });
        await Promise.all(validations);
      }
    }
  }

  deleteItemsNotAllowed = async (getCart, tipoDeleted, tipoPlan) => {
    if (getCart.success && getCart.data && getCart.data.data) {
      const { items } = getCart.data.data || [];
      let cartResponse;
      const borrar = {
        PREPAGO: [],
        POSPAGO: [],
        PLAN: [],
        ADDONS: [],
        GARANTIA: [],
        OTRO: [],
      };
      items.forEach((it) => {
        const tipo = product.tipo(it.product);
        borrar[tipo].push(it);
      });
      if (tipoDeleted === 'PLAN') {
        if (tipoPlan.toUpperCase() === 'FIJO') {
          cartResponse = borrar.POSPAGO.length || borrar.ADDONS.length || borrar.GARANTIA.length ? await Promise.all([...borrar.POSPAGO, ...borrar.ADDONS, ...borrar.GARANTIA].map(e => this.props.orderStore.deleteToCart(e.part_number))) : [getCart];
        } else {
          cartResponse = borrar.ADDONS.length ? await Promise.all(borrar.ADDONS.map(e => this.props.orderStore.deleteToCart(e.part_number))) : [getCart];
        }
      } else if (tipoDeleted === 'PREPAGO') {
        cartResponse = borrar.PREPAGO.length ? await Promise.all(borrar.PREPAGO.map(e => this.props.orderStore.deleteToCart(e.part_number))) : [getCart];
      } else if (tipoDeleted === 'POSPAGO') {
        cartResponse = borrar.ADDONS.length || borrar.PLAN.length || borrar.GARANTIA.length ? await Promise.all([...borrar.ADDONS, ...borrar.PLAN, ...borrar.GARANTIA].map(e => this.props.orderStore.deleteToCart(e.part_number))) : [getCart];
      } else {
        cartResponse = [getCart];
      }
      if (cartResponse && cartResponse.length) {
        cartResponse = cartResponse[cartResponse.length - 1];
        if (cartResponse.success) {
          this.moreProducts(cartResponse.data.data.items, true);
        }
      }
    }
  };

  validPrepago = async (prepagoItems) => {
    const prepagoLength = prepagoItems.filter(it => product.tipoPlan(it.product.items[0]) !== 'SIM').reduce((qt, it) => qt + +it.quantity, 0);
    if (prepagoLength > 1) {
      this.setState({ warnMessage: 'Carrito con productos mal configurados. Trata de agregarlos nuevamente.' });
      return false;
    }
    return true;
  }

  addAddOns = async (e) => {
    e?.preventDefault();
    let partNumber;
    const getCart = await this.props.orderStore.getCart();

    // filtrar el part number que pertenece a la tarjeta de prepago.
    if (getCart.success && getCart.data && getCart.data.data) {
      const { items } = getCart.data.data;

      const addons = this.state.addonsList || [];
      const cartItems = items.filter(item => !addons.some(addon => addon.item_part_number === item.part_number));
      const validPrepago = await this.validPrepago(cartItems.filter(it => it.product.type === '1'));
      const cartValid = cartItems.length;
      const hasPospago = cartValid > 0 && items.some(it => product.tipo(it.product.items[0]) === 'POSPAGO');
      const hasPlanFijo = cartValid > 0 && items.some(it => product.tipo(it.product.items[0]) === 'PLAN' && product.tipoPlan(it.product.items[0]) === 'FIJO');
      if (validPrepago && cartValid && hasPospago === hasPlanFijo) {
        const invStatus = items.map(item => this.props.catalogStore.inventoryStatusService(item.part_number));
        const invStatusRes = await Promise.all(invStatus);
        let checkoutLock = false;
        for (let i = 0; i < invStatusRes.length; i += 1) {
          const inventoryStatus = invStatusRes[i];
          if (inventoryStatus && inventoryStatus.data && inventoryStatus.data.data) {
            if (!inventoryStatus.data.data.available || !inventoryStatus.data.data.buyable
              || inventoryStatus.data.data.quantity < +items[i].quantity) {
              partNumber = inventoryStatus.data.data.partnumber;
              break;
            }
          } else {
            checkoutLock = true;
            this.setState({ checkoutLock });
            break;
          }
        }
        if (!checkoutLock) {
          if (partNumber) {
            this.setState({ cardMessageError: { errorKey: '_API_BAD_INV', errorParameters: `${partNumber},0` } });
          } else {
            this.props.history.push('/checkout/address');
          }
        }
      } else if (!cartValid) {
        items.map(item => this.props.orderStore.deleteToCart(item.part_number));
      } else {
        this.setState({ warnMessage: 'Carrito con productos mal configurados. Trata de agregarlos nuevamente.' });
      }
    }
  };

  deleteItem = async (partNumber, tipo, tipoPlan) => {
    const cart = this.props.orderStore.getCartInfo.data.data;
    const response = await this.props.orderStore.deleteToCart(partNumber);
    if (response.success) {
      analytics.removeFromCart(cart, partNumber);
      this.deleteItemsNotAllowed(response, tipo, tipoPlan);
    }
  };

  productWarn = async () => {
    const [dataPerson] = await Promise.all([
      this.props.accountStore.dataPerson(),
    ]);

    if (dataPerson && dataPerson.success) {
      return true;
    } else {
      const query = new URLSearchParams(this.props.location.search);
      const querySource = query.get('source');
      if (querySource === 'carritoabandonado') {
        $('.modal').toggleClass('active').show();
        $('.modal--user').toggleClass('active');
      }
      return false;
    }
  };

  addToCart = async (item) => {
    let query;
    const itemAttr = product.convertAttributes(item.attributes);
    if ((itemAttr['attr-conf-validacion-correo'] || '').toLowerCase() === 'si') {
      const dataPerson = await this.props.accountStore.dataPerson();
      if (dataPerson && dataPerson.success) {
        const addonResponse = await this.props.orderStore.validateAddon({
          validateAddon: {
            mail: dataPerson.data.data.logon_id,
            sku: item.part_number,
          },
        });
        if (addonResponse && addonResponse.success) {
          query = {
            part_number: item.part_number,
            quantity: 1,
            mail: dataPerson.data.data.logon_id,
          };
        } else {
          this.setState({ warnMessage: 'No se puede asociar.' });
        }
      } else {
        this.setState({ warnMessage: 'Inicia sesión para agregar este producto.' });
      }
    } else if (product.tipo(item) === 'PLAN') {
      query = {
        part_number: item.part_number,
        quantity: 1,
      };
      const dataPerson = await this.props.accountStore.dataPerson();
      if (dataPerson && dataPerson.success) {
        query.mail = dataPerson.data.data.logon_id;
      }
    } else {
      query = {
        part_number: item.part_number,
        quantity: 1,
      };
    }
    if (query) {
      const addResponse = await this.props.orderStore.addToCart(query);
      if (addResponse.success) {
        await this.moreProducts(addResponse.data.data.items, true);
      }
    }
  };

  moreProducts = async (items, renderizar) => {
    if (items.length) {
      const item = items.find(it => product.tipo(it.product.items[0]) === 'PLAN');
      const prepagoItems = items.filter(it => product.tipo(it.product.items[0]) === 'PREPAGO');
      if (prepagoItems.length === 1) {
        const it = prepagoItems[0];
        if (product.tipoPlan(it.product.items[0]) === 'SIM') {
          const res = await this.props.orderStore.deleteToCart(it.part_number);
          if (!res.success) {
            this.setState({ warnMessage: 'Ha ocurrido un error. Recarga la página, por favor.' });
          }
          prepagoItems.length = 0;
        }
      } else if (prepagoItems.length > 1) {
        await this.validPrepago(prepagoItems);
      }
      const prepago = prepagoItems.length;
      const hasPospago = items.some(it => product.tipo(it.product.items[0]) === 'POSPAGO');
      const hasPlanFijo = !!item && product.tipoPlan(item.product.items[0]) === 'FIJO';
      if (hasPospago !== hasPlanFijo) {
        this.setState({ warnMessage: 'Carrito con productos mal configurados. Trata de agregarlos nuevamente.' });
      }
      this.state.tipo = item ? 'PLAN' : prepago ? 'PREPAGO' : 'OTRO';
      const values = [];
      switch (this.state.tipo) {
        case 'PREPAGO': {
          values.push('PLAN');
          const res = await addonsList();
          const addonslist = res.data[0].filter(x => x.enabled === true && x.auto_cart === true);
          const filt = addonslist.filter(e => !items.some(x => e.item_part_number === x.part_number));
          if (filt && filt.length) {
            await Promise.all(filt.map(async (e) => {
              const response = await this.props.orderStore.addToCart({
                part_number: e.item_part_number,
                quantity: e.quantity,
              });
              if (response && !response.success) {
                this.setState({ cardMessageError: (response.error && response.error.data && response.error.data.errors && response.error.data.errors[0]) || { errorKey: '_API_BAD_INV', errorParameters: `${e.item_part_number},0` } });
              }
            }));
          }
          break;
        }
        case 'PLAN': {
          if (prepago) {
            const res = await addonsList();
            const addonslist = res.data[0].filter(x => x.enabled === true && x.auto_cart === true);
            const filt = addonslist.filter(e => !items.some(x => e.item_part_number === x.part_number));
            if (filt && filt.length) {
              await Promise.all(filt.map(async (e) => {
                const response = await this.props.orderStore.addToCart({
                  part_number: e.item_part_number,
                  quantity: e.quantity,
                });
                if (response && !response.success) {
                  this.setState({ cardMessageError: (response.error && response.error.data && response.error.data.errors && response.error.data.errors[0]) || { errorKey: '_API_BAD_INV', errorParameters: `${e.item_part_number},0` } });
                }
              }));
            }
          } else if (hasPospago) {
            values.push('GARANTIA');
          } else {
            values.push('PREPAGO');
          }
          values.push('ADDONS');
          const planAttr = product.convertAttributes(item.product.items[0].attributes);
          const itemsAddons = items.filter(ci => product.tipo(ci.product.items[0]) === 'ADDONS');
          for (let j = 0; j < itemsAddons.length; j += 1) {
            const itemAddon = itemsAddons[j];
            const addonAttr = product.convertAttributes(itemAddon.product.items[0].attributes);
            const tipoplan = addonAttr['attr-conf-tipoplan'] || '';
            if ((planAttr[`attr-paquete-${tipoplan}`] || '').toLowerCase() === 'si') {
              this.props.orderStore.deleteToCart(itemAddon.part_number);
            }
          }
          break;
        }
        default:
          break;
      }
      if (this.state.tipo === 'OTRO') {
        const recom = await this.props.orderStore.getRecommendations();
        if (recom.success) {
          this.props.catalogStore.catalogResponse = recom.data;
        } else {
          this.props.catalogStore.catalogResponse = { data: [] };
        }
      } else {
        this.props.catalogStore.products({
          attribute: 'attr-conf-tipoproducto',
          values,
        });
      }
      if (renderizar) {
        this.setState({ tipo: this.state.tipo });
      }
      this.sendAnalytics();
    } else {
      this.setState({ tipo: '' });
    }
  }

  closeWarn = () => {
    this.setState({ warnMessage: null });
  }

  openModal() {
    $('.modal').fadeIn();
    $('.modal--customer').addClass('active');
  }

  goTop() {
    document.getElementById('initial').scrollIntoView(true);
  }

  render() {
    let cartInfo;
    const orderInfo = this.props.orderStore.getCartInfo;
    let checkoutRedirect;

    if (
      orderInfo
      && orderInfo.data
      && orderInfo.data.data
      && orderInfo.data.data.items
      && orderInfo.data.data.items.length
    ) {
      this.isEmpty = false;
      cartInfo = orderInfo.data.data;
    } else {
      this.isEmpty = true;
    }
    // console.log("checkoutLock", this.state.checkoutLock);
    if (this.state.checkoutLock || this.state.cardMessageError) {
      checkoutRedirect = (
        <a
          className="cart--limit-msg"
          onClick={() => {
            this.goTop();
          }}
        >
          <span>Los productos están agotados por ahora.</span>
        </a>
      );
    } else if (this.state.checkoutRedirect) {
      checkoutRedirect = this.state.checkoutRedirect;
    }

    return (
      <UI
        cartInfo={cartInfo}
        isEmpty={this.isEmpty}
        checkoutRedirect={checkoutRedirect}
        deleteItem={this.deleteItem}
        cardMessageErrorProp={this.state.cardMessageError}
        addOnsList={this.state.addonsList}
        addonsListState={this.state.addonsListState}
        tipo={this.state.tipo}
        addToCart={this.addToCart}
        warnMessage={this.state.warnMessage}
        closeWarn={this.closeWarn}
      />
    );
  }
}

Cart.propTypes = {
  accountStore: PropTypes.shape({
    dataPerson: PropTypes.func,
    ordersPerson: PropTypes.func,
    person: PropTypes.shape({
      data: PropTypes.shape({}),
      success: PropTypes.bool,
      userGuest: PropTypes.bool,
    }),
  }),
  orderStore: PropTypes.shape({
    addToCart: PropTypes.func,
    getCart: PropTypes.func,
    deleteToCart: PropTypes.func,
    validateCart: PropTypes.func,
    validateAddon: PropTypes.func,
    onUpdateCart: PropTypes.func,
    warnedUser: PropTypes.bool,
    refreshOrder: PropTypes.func,
    getCartInfo: PropTypes.shape({
      data: PropTypes.shape({
        data: PropTypes.shape({
          items: PropTypes.arrayOf(PropTypes.shape({})),
        }),
      }),
    }),
  }),
  catalogStore: PropTypes.shape({
    inventoryStatusService: PropTypes.func,
    products: PropTypes.func,
  }),
};

Cart.defaultProps = {
  accountStore: {},
  orderStore: {},
  catalogStore: {},
};

export default inject('orderStore', 'accountStore', 'catalogStore')(observer(withRouter(Cart)));
